import * as f from '../../components/BPMTable/BPMInputs'
import { 
    DataTransformer, 
    FormFieldDescription,
    FormSection,
} from '../../components/BPMTable/TableMapperCreator'
import FormCreatorCreator from '../../components/BPMTable/FormCreatorFactory/FormCreatorCreator'
import UserMinimalTable from '../../pages/Inventory/User/MinimalTable'
import formCreatorCreatorFactoryCreators from '../../components/BPMTable/FormCreatorFactory/FormCreatorCreatorFactoryCreator'
import { bayphoneUserQueries } from './BayphoneUserTableDefinitions'


class BayphoneUserFormCreator extends FormCreatorCreator{
    constructor() {
        super()
    }

    static getId = () => {
        return "BayphoneUserFormCreator"
    }

    getFormCreator = () => {
        const formCreator = this.createFormCreator(this.constructor.getId(), 'Bayphone User', bayphoneUserQueries)
        const userTablePicker = new UserMinimalTable({first: 15, orderDirection: "asc", orderField: "firstName", isActive:true})

        const bayphoneUserSection = new FormSection('User', 1)
        const generalSection = new FormSection('General', 2)

        formCreator.addInputs([
            new FormFieldDescription(
                'user',
                new f.InputDescription(new f.ModelCreator('user', userTablePicker), new f.RequiredValidator(1)),
                bayphoneUserSection,
                1,
                { label: 'User', transform: new DataTransformer(data=> data, data=> data) }
            ),
            new FormFieldDescription(
                'sales',
                new f.InputDescription(new f.BoolCreator('sales', false), true),
                generalSection,
                2,
                {label: 'Sales'}
            ),
            new FormFieldDescription(
                'isActive',
                new f.InputDescription(new f.BoolCreator('isActive', true), true),
                generalSection,
                3,
                {label: 'Is Active'}
            ),
        ]);
    
        return formCreator;
    }
}

formCreatorCreatorFactoryCreators.addFormCreatorCreator(BayphoneUserFormCreator)

export default BayphoneUserFormCreator